<template>
	<el-dialog title="新增任务" :visible.sync="dialogFormVisible" width="800px" :center="true">
        <el-form :model="formNew" ref="formNew" :rules="rules" label-width="110px" class="demo-form-inline" size="small">
          <el-form-item label="所属用户/组织" :label-width="formLabelWidth" prop="parent">
            <el-input v-model="formNew.parent" autocomplete="off" :disabled="true" class="fm2-input-text-wth"></el-input>
          </el-form-item>
          <el-form-item label="任务名称" :label-width="formLabelWidth" prop="task_name">
            <el-input v-model="formNew.task_name" autocomplete="off" placeholder="请输入任务名称" class="fm2-input-text-wth"></el-input>
          </el-form-item>
          <el-form-item label="线路" prop="road_id">
        	  <el-select v-model="formNew.road_id" placeholder="选择线路" style="width:200px;">
              <el-option
                v-for="item in road_options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
      	  </el-form-item>
          <el-form-item label="开始-结束时间" prop="time">
            <el-time-select
              placeholder="起始时间"
              v-model="formNew.start_time"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59'
              }">
            </el-time-select>
              &nbsp;&nbsp;
            <el-time-select
              placeholder="结束时间"
              v-model="formNew.end_time"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59',
                minTime: formNew.startTime
              }">
            </el-time-select>
          </el-form-item>
          <el-form-item label="周期模式">
            <el-radio v-model="rdoCycleMode" label="1" border size="medium">单次任务</el-radio>
            <el-radio v-model="rdoCycleMode" label="2" border size="medium">每天重复</el-radio>
            <el-radio v-model="rdoCycleMode" label="3" border size="medium">每周重复</el-radio>
            <el-radio v-model="rdoCycleMode" label="4" border size="medium">每月重复</el-radio>
          </el-form-item>
          <el-form-item label="每周重复" v-show="rdoCycleMode == '3'">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group v-model="checkedWeeks" @change="handleCheckedWeeksChange">
              <el-checkbox v-for="week in weeks" :label="week" :key="week">{{week}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="每月重复" v-show="rdoCycleMode == '4'">
              <el-checkbox :indeterminate="isMonthIndeterminate" v-model="checkMonthDaysAll" @change="handleCheckAllMonthDaysChange">全选</el-checkbox>
              <div style="margin: 15px 0;"></div>
              <el-checkbox-group v-model="checkedMonthDays" @change="handleCheckedMonthDaysChange">
                <el-checkbox v-for="day in monthDays" :label="day" :key="day">{{day}}</el-checkbox>
              </el-checkbox-group>
          </el-form-item>
          <el-form-item label="到期时间" :label-width="formLabelWidth" prop="expire_date">
            <el-date-picker
              v-model="formNew.expire_date"
              type="date"
              placeholder="选择日期" 
              style="width:200px;">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="设备(人员)" prop="object_id">
        	  <el-select v-model="formNew.object_id" placeholder="选择设备(人员)" style="width:200px;">
              <el-option
                v-for="item in device_options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
      	  </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="saveRoadTask()" size="small">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import Api from '../../api/index'

const weekOptions = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
const monthOptions = [];
for(var i=1; i<=31; i++) {
	monthOptions.push(`${i}号`);
}

export default {
  name: "RoadTaskForm",
  data() {
    return {
        dialogFormVisible: false,
        formLabelWidth: '110px',
        displayPassword: true,
        parent_id: 0,
        rules: {
            task_name: [
            { required: true, message: '请输入任务名称', trigger: 'blur' }
          ]
        },
        checkedWeeks: ['周一', '周二', '周三', '周四', '周五'],
        monthDays: monthOptions,
        weeks: weekOptions,
        checkAll: false,
        checkMonthDaysAll: false,
        isIndeterminate: true,
        isMonthIndeterminate: true,
        checkedMonthDays: [],
        rdoCycleMode: "1",
        road_options: [],
        device_options: [],
        formNew: {
          task_id: 0,
          road_id: "",
          parent: "",
          task_name: "",
          object_id: "",
          device_item: "",
          expire_date: null,
          start_time: "",
          end_time: ""
        },
        transferCard: {
        	data: [],
        	value: []
        }
    }
  },
  methods: {
    handleCheckAllChange(val) {
	    this.checkedWeeks = val ? weekOptions : [];
	    this.isIndeterminate = false;
    },
    handleCheckAllMonthDaysChange(val) {
	    this.checkedMonthDays = val ? monthOptions : [];
	    this.isMonthIndeterminate = false;
    },
    handleCheckedWeeksChange(value) {
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.weeks.length;
        this.isMonthIndeterminate = checkedCount > 0 && checkedCount < this.weeks.length;
    },
    handleCheckedMonthDaysChange(value) {
        let checkedCount = value.length;
        this.checkMonthDaysAll = checkedCount === this.monthDays.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.monthDays.length;
    },
    show: function(id, parent_id) {
        this.dialogFormVisible = true;
        this.parent_id = parent_id;
        this.rdoCycleMode = "1";
        this.checkedWeeks = [];
        this.checkedMonthDays = [];
        this.formNew.road_id = "";
        this.formNew.task_name = "";
        this.formNew.object_id = "";
        this.formNew.expire_date = null;
        this.formNew.start_time = "";
        this.formNew.end_time = "";

        if(id > 0) {
          // id > 0时parent_id无参考意义
          this.displayPassword = false;
          Api.GetRoadTaskDetail({ task_id: id }).then(res => {
            if(!res)
              return;

            if(res.code !== 200) {
              this.$message.error(res.msg);
            }

            if(res.data) {

              this.parent_id = res.data.hold_id;

              this.bindRoadOptions();
              this.bindDeviceOptions();

              this.formNew.task_id = res.data.task_id;
              this.formNew.road_id = res.data.road_id;
              this.formNew.task_name = res.data.task_name;
              this.formNew.object_id = res.data.object_id ? res.data.object_id + "" : "";
              if(res.data.expire_time) {
                var _milliseconds = Date.parse(res.data.expire_time);
                this.formNew.expire_date = new Date(_milliseconds);
              }
              this.formNew.start_time = res.data.start_time;
              this.formNew.end_time = res.data.end_time;
              this.formNew.object_id = res.data.object_id;

              Api.LoadParentBase({ id: this.parent_id }).then(res => {
                if(!res && res.code !== 200)
                  return;

                if(res.data) {
                  this.formNew.hold_id = res.data.hold_id;
                  this.formNew.parent = res.data.hold_name;
                }
              });
            }
          }).catch(err => {
              this.$message.error('错了哦，接口出错！' + err);
          });
        } else {
          this.displayPassword = true;

          Api.LoadParentBase({ id: this.parent_id }).then(res => {
            if(!res && res.code !== 200)
              return;

            if(res.data) {
              this.formNew.parent = res.data.hold_name;
            }
          });

          this.bindRoadOptions();
          this.bindDeviceOptions();
        }
    },
    bindRoadOptions: function() {
      this.road_options = [];
      var argdata = {
        hold_id: this.parent_id
      };
      Api.GetRoadOptions(argdata).then(res => {
        if(!res && res.code !== 200)
          return;

        if(res.data) {
          res.data.forEach(item => {
            this.road_options.push({
              value: item.road_id,
              label: item.road_name
            });
          });
        }
      });
    },
    bindDeviceOptions: function() {
      this.device_options = [];
      var argdata = {
        hold_id: this.parent_id
      };
      Api.GetDeviceOptions(argdata).then(res => {
        if(!res && res.code !== 200)
          return;

        if(res.data) {
          res.data.forEach(item => {
            this.device_options.push({
              value: item.object_id,
              label: item.object_name
            });
          });
        }
      });
    },
    saveRoadTask: function() {
      if(this.parent_id < 1) {
        this.$message.error('数据异常，无法保存！');
        return;
      }

      if(!this.formNew.road_id) {
        this.$message.error('请选择线路');
        return;
      }

      var repeatValue = "";
      if(this.rdoCycleMode == "3") {
        repeatValue = this.checkedWeeks.join(",");
      } else if(this.rdoCycleMode == "4") {
        repeatValue = this.checkedMonthDays.join(",");
      }

      var expireDate = "";
      if(this.formNew.expire_date) {
        console.log(this.formNew.expire_date);
        var year = this.formNew.expire_date.getFullYear(); // 获取年份
        var month = this.formNew.expire_date.getMonth() + 1; // 获取月份
        var day = this.formNew.expire_date.getDate(); // 获取日期
        expireDate = year + '-' + month + '-' + day;
      }
      
      
      var argdata = {
        task_id: this.formNew.task_id,
        hold_id: this.parent_id,
        task_name: this.formNew.task_name,
        road_id: parseInt(this.formNew.road_id),
        object_id: this.formNew.object_id ? parseInt(this.formNew.object_id) : 0,
        cycle_repeat_mode: parseInt(this.rdoCycleMode),
        cycle_repeat_value: repeatValue,
        expire_date: expireDate,
        start_time: this.formNew.start_time,
        end_time: this.formNew.end_time
      };
      console.log(argdata);
      Api.SaveRoadTask(argdata).then(res => {
        if(!res) {
          this.$message.error('出错了！');
          return;
        }

        if(res.code !== 200) {
          this.$message.error(res.msg);
          return;
        }

        console.log(res);

        this.$message({
          message: '恭喜你，提交成功！',
          type: 'success'
        });

        this.$emit("eventRefreshTableName");
        this.dialogFormVisible = false;
      });
    }
  }
}
</script>